import React from "react";

const url =
  "https://techatshopee.formstack.com/forms/thailand_data_challenge_2020";
class RegisterNotYet extends React.Component {
  render() {
    const { msg } = this.props;
    return (
      <React.Fragment>
        <p>
          {/* Registration opens on <strong>25 Jan 2020</strong> and closes on{" "}
          <strong>8 Mar 2020</strong>. */}
          {msg.registerDuration[0]} <strong>{msg.registerDuration[1]}</strong>{" "}
          {msg.registerDuration[2]} <strong>{msg.registerDuration[3]}</strong>.
        </p>
        {/* <a
          href={url}
          className="btn btn-primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {msg.registerNow}
        </a> */}
      </React.Fragment>
    );
  }
}

class RegisterOnGoing extends React.Component {
  render() {
    const { msg } = this.props;
    return (
      <React.Fragment>
        <p>{msg.registerNowDesc}</p>
        <a
          href={url}
          className="btn btn-primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {msg.registerNow}
        </a>
      </React.Fragment>
    );
  }
}

class RegisterClose extends React.Component {
  render() {
    const { msg } = this.props;
    return (
      <React.Fragment>
        <p>{msg.registerClose}</p>
      </React.Fragment>
    );
  }
}

class Register extends React.Component {
  constructor() {
    super();
    this.entry = undefined;
  }

  render() {
    const msg = this.props.Message;
    // 22 Jul 2019 - Registration Opens
    // 10 Sep 2019 - Registration Closes
    // Date: new Date().getTime() today 1562040427128
    const regStart = new Date("Jan 22 2020 00:00:00").getTime(),
      regEnd = new Date("Mar 08 2020 23:59:59").getTime(),
      // today = new Date("Jan 25 2020 00:00:01").getTime();
      today = new Date().getTime();
    if (today < regStart) {
      this.entry = <RegisterNotYet msg={msg} />;
    } else if ((today > regStart) & (today < regEnd)) {
      this.entry = <RegisterOnGoing msg={msg} />;
    } else if (today > regEnd) {
      this.entry = <RegisterClose msg={msg} />;
    } else {
      this.entry = <RegisterNotYet msg={msg} />;
    }

    return (
      <section id="register" className="white">
        <div className="container">
          <div className="box" style={{ padding: "100px 0 90px" }}>
            <div className="section-title">
              <h2>{msg.register}</h2>
            </div>
            {this.entry}
          </div>
        </div>
      </section>
    );
  }
}

export default Register;
